"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var date_1 = require("../../../common/utils/date");
var format_1 = require("./format");
var Countdown = /** @class */ (function (_super) {
    tslib_1.__extends(Countdown, _super);
    function Countdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            current: _this.getCurrent(),
        };
        return _this;
    }
    Countdown.prototype.componentDidMount = function () {
        this.update();
    };
    Countdown.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeout);
    };
    Countdown.prototype.update = function () {
        var _this = this;
        var step = this.props.step;
        var current = this.getCurrent();
        this.setState({
            current: current,
        });
        if (current > 0) {
            this.timeout = setTimeout(function () { return _this.update(); }, step);
        }
    };
    Countdown.prototype.getCurrent = function () {
        var until = this.props.until;
        return until - Date.now();
    };
    Countdown.prototype.render = function () {
        var _a = this.props, isFocusable = _a.isFocusable, titlePrefix = _a.titlePrefix, className = _a.className;
        var current = this.state.current;
        var time = (0, format_1.formatTime)(current);
        return (react_1.default.createElement("span", { className: className, role: "timer", "aria-label": "".concat(titlePrefix, " ").concat(time), tabIndex: isFocusable ? 0 : -1, dir: "auto" }, time));
    };
    Countdown.defaultProps = {
        step: date_1.MILLISECONDS.ONE_SECOND,
        titlePrefix: '',
    };
    return Countdown;
}(react_1.default.Component));
exports.default = Countdown;
//# sourceMappingURL=countdown.js.map